'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import ButtonBox from './ButtonBox.mjs';
import { BUTTON_BOX_SIZE } from '../../constants/button.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';
import styles from './ButtonBoxDouble.module.scss.mjs';

const cx = classNames.bind(styles);
/**
 *
 * - size
 *    - `max` | `largefull` |  `large` | `medium`
 *
 */
const ButtonBoxDouble = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    size,
    ratio,
    leftButton,
    rightButton
  } = _ref;
  useApplyLogging('ButtonBoxDouble');
  const innerButtonWideProps = size === BUTTON_BOX_SIZE.MAX ? {} : {
    isWide: true
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', `size-${size}`, `type-${ratio}`),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('cell')
  }, /*#__PURE__*/React.createElement(ButtonBox, {
    ...{
      ...leftButton,
      size,
      ...innerButtonWideProps
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('cell')
  }, /*#__PURE__*/React.createElement(ButtonBox, {
    ...{
      ...rightButton,
      size,
      ...innerButtonWideProps
    }
  })));
});
ButtonBoxDouble.displayName = 'ButtonBoxDouble';

export { ButtonBoxDouble as default };
